import React from 'react';
import styled from 'styled-components';

import CircularProgress from '@joinforma/ui/components/CircularProgress';

const Container = styled.div`
  background: rgba(0, 0, 0, 0.4);
  z-index: 1054;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  active: boolean;
};

const Loader = ({ active }: Props) =>
  active ? (
    <Container>
      <CircularProgress />
    </Container>
  ) : (
    <div />
  );

export default Loader;
